import React, { Component } from 'react'
import { t } from 'i18next'
import './index.css'

export default class Specifications extends Component {
  render() {
    const content = [
      {
        title: t('bizon_prefab_house'),
        fields: [
          [t('costs'), `${t('from')} €490/m²`],
          [t('construction_time'), `2 ${t('weeks')}`],
          [t('energy_use'), `${t('up_to')} 30 kWh/m² ${t('per_year')}`],
          [t('warranty'), `20 ${t('year')}`]
        ]
      },
      {
        title: t('traditional_house'),
        fields: [
          [t('costs'), `${t('from')} €900/m²`],
          [t('construction_time'), `1 ${t('year')}`],
          [t('energy_use'), `45 – 275 kWh/m² ${t('per_year')}`],
          [t('warranty'), `~ 6 ${t('year')}`]
        ]
      }
    ]

    return (
      <div className="ProsCons">
        {content.map((x, i) =>
          <div key={`proscons-item-${i}`} className="item">
            <div className="box">
              {x.fields.map((y, i) =>
                <dl key={`proscons-fields-${i}`}>
                  <dt>{y[0]}</dt>
                  <dd>{y[1]}</dd>
                </dl>
              )}
            </div>
            <h3>{x.title}</h3>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/ProsCons/index.js